import CryptoJS from 'crypto-js';

function createSystemIdentifier(salt) {
  const properties = [
    navigator.platform,
    navigator.userAgent.split(' ')[0],
    navigator.hardwareConcurrency,
    window.screen.width,
    window.screen.height,
  ];
  const identifier = properties.map(property => property.toString()).join('-');
  const saltedIdentifier = identifier + salt;
  const hash = CryptoJS.SHA256(saltedIdentifier).toString(CryptoJS.enc.Base64);
  return hash;
}

export default createSystemIdentifier;
